import { useFormikContext } from 'formik';
import { isEqual } from 'lodash';

import { useJobContext } from 'hb-react/shared/apps/JobForm/contexts/JobContext';
import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import { CustomAttribute } from 'hb-react/shared/components/formik/components/inputs';

import { Section } from './Section';
import { type FormValues } from '../types';

export const Custom = ({ isActive }: { isActive?: boolean }) => {
  const { values } = useFormikContext<FormValues>();

  const { kindConfigurations = [] } = useJobContext();

  const { customizable_attributes: customAttrs = [] } =
    kindConfigurations.find(({ kind_id: kindId }) =>
      isEqual(kindId, values.kind_id),
    ) || {};

  if (isActive && customAttrs.length) {
    const visibleCustomAttrs = customAttrs.filter(
      ({ visibility }) => visibility === 'everybody',
    );

    return (
      <Section
        title={s__(
          'JobForm|Collect additional information for this opportunity',
        )}
      >
        <Grid mx={0} rowGap={0}>
          <Row>
            {visibleCustomAttrs.map((customAttr) => (
              <Col
                key={customAttr.name}
                overrideRowGap={0}
                width={{ _: 1, m: 0.5 }}
              >
                <CustomAttribute
                  customAttribute={customAttr}
                  name={customAttr.name}
                />
              </Col>
            ))}
          </Row>
        </Grid>
      </Section>
    );
  }

  return null;
};
